// 统计模块路由配置 - 简化版
export const statisticsRoutes = [
  {
    path: '/dashboard',
    component: () => import('@/layouts/MainLayout.vue'),
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        name: 'Dashboard',
        component: () => import('@/views/statistics/UserStatisticsPage.vue'),
        meta: {
          title: '仪表盘',
          icon: 'el-icon-data-board',
          requiresAuth: true,
          roles: ['user', 'admin', 'manager', 'analyst']
        }
      }
    ]
  },
  {
    path: '/statistics',
    component: () => import('@/layouts/MainLayout.vue'),
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        name: 'UserStatistics',
        component: () => import('@/views/statistics/UserStatisticsPage.vue'),
        meta: {
          title: '我的统计',
          icon: 'el-icon-data-board',
          requiresAuth: true,
          roles: ['user', 'admin', 'manager', 'analyst']
        }
      }
    ]
  }
]
